<template>
  <Modal v-model="modal" :title="item.Number" :mask-closable="false">
    <div>
      <Row :gutter="56">
        <Col span="13">
          <div class="item">
            <div class="t">
              <b>{{$t('label.w71')}}</b>
              <br>
              <span :class="{'text-warning':rate>itemrate}">{{$t('label.w72')}} +{{rate>itemrate?(rate-itemrate).toFixed(1):0}}%</span>
            </div>
            <div>
              <Input :style="{width:'140px'}" @on-blur="blur" v-model="rate">
                <span slot="append" class="f14">%</span>
              </Input>
            </div>
          </div>
          <div v-if="per!==null" class="text-warning">{{$t('msg.m74').replace('{%}',per)}}</div>
        </Col>
        <Col span="11">
          <div class="item">
            <div class="t">
              {{$t('label.w73')}}
              <br>{{$t('label.w74')}}
            </div>
            <div>
              <b>
                {{item.ExpiredAt}}
                <br>
                {{item.Progress}}%
              </b>
            </div>
          </div>
        </Col>
      </Row>
      <Divider dashed size="small"/>
      <Row :gutter="56">
        <Col span="13">
          <div class="item auto">
            <div class="t">{{$t('label.w75')}}</div>
            <div class="f18">{{interest*item.TotalPhase | money}} {{$t('label.w5')}}</div>
          </div>
        </Col>
        <Col span="11">
          <div class="item auto">
            <div class="t">{{$t('label.w76')}}</div>
            <div class="f18">{{item.TotalManagementFee | money}} {{$t('label.w5')}}</div>
          </div>
        </Col>
      </Row>
    </div>
    <template slot="footer">
      <div class="foottext">{{$t('label.w77').replace('{%}',item.TotalPhase)}} x {{$t('label.w78')}} <span class="text-warning">{{interest+managefee | money}}</span>{{$t('label.w5')}}（{{$t('label.w52')}}{{interest | money}}{{$t('label.w5')}}+{{$t('label.w55')}}{{managefee | money}}{{$t('label.w5')}}）<br/>{{$t('label.w79')}}：{{lastamount | money}}{{$t('label.w5')}}</div>
      <Button type="primary" :disabled="rate==''||rate<itemrate" :loading="loading" @click="submit">{{$t('btn.b5')}}</Button>
    </template>
  </Modal>
</template>
<script>
import { digitUppercase } from "@/libs/static"
import comp from "@/libs/comp"
export default {
  data() {
    return {
      modal: false,
      type: 1,
      item: {},
      loading: false,
      rate: 0,
      per:null
    };
  },
  methods: {
    async submit() {
      this.loading = true;
      let res= await this.$axios.post("/Member/RZJLoan/LoanSchemeAddRate", {
          loanSchemeId: this.item.Id,
          rate:this.rate
        });
      this.loading = false;
      res.throw();
      if (!res.err) {
        this.modal = false;
        this.$emit("done");
      }
    },
    async getper(){
      if(this.item.LoanType!==0) return;
      let res=await this.$axios.get('/Member/RZJLoan/LoanSchemeAddRateTip',{
        params:{
          amount:this.item.Amount,
          pledgeIds:this.item.PledgeIds,
          rate:this.rate,
          loanCycleDay:this.item.LoanCycleValue
        }
      })
      if(res.err) return this.per=null;
      this.per=res
    },
    blur(){
      if(this.rate>25){
        this.rate = 25
      }
      else if(this.rate < this.itemrate) {
        this.$Message.error(this.$t('msg.m95'));
        this.rate = this.itemrate;
      }else{
        this.rate =this.rate.replace(/(\.\d)\d+/,'$1')
        this.getper()
      }
    }
  },
  computed:{
    interest(){
      return comp.interest(
        this.item.Amount,
        this.rate/100,
        this.item.LoanCycleValue
      )
    },
    managefee(){
      return this.item.ManagementFee
    },
    lastamount(){
      return this.item.Amount+this.interest+this.managefee
    },
    itemrate(){
      let rate=this.item.Rate
      if(this.item.AddRate) rate+=this.item.AddRate
      return Number((rate*100).toFixed(1))
    }
  },
  watch: {
    modal(v) {
      if (!v) return;
      this.rate = this.itemrate;
      this.getper()
    }
  }
};
</script>
<style lang="less" scoped>
.f14 {
  font-size: 14px;
}
.f18 {
  font-size: 18px;
}
.item {
  display: flex;
  height: 40px;
  align-items: center;
  .t {
    color: #7b7b7c;
    display: block;
    width: 80px;
  }
  &.auto{
    height: inherit;
  }
}
b {
  font-weight: normal;
  color: #000;
}
/deep/ .ivu-divider-horizontal{
  margin: 15px 0;
}
/deep/ .ivu-modal-body{
  padding-bottom: 20px;
}
.foottext{
  float: left;
  text-align: left;
}
</style>
